import { useEffect } from 'react';

import { useApplicationContext } from './applicationContext';
import { isWebView } from './isWebView';

/* Хук для мутации ссылок при клике на них
 * Подставляет target="_blank" ссылке, чтобы она не открывалась в текущем окне.
 * Необходимо для внешних интеграций
 */
export function useAnchorTargetBlank() {
  const { config } = useApplicationContext();

  const isWebview = isWebView(config);
  const isAnchorTargetBlankEnabled = !!config.get('frontend-chats.AnchorTargetBlank.Enabled');

  const isFeatureAvailable = !isWebview && isAnchorTargetBlankEnabled;

  useEffect(() => {
    if (!isFeatureAvailable) {
      return;
    }

    const handleClick = (event: MouseEvent) => {
      const link = event.target as HTMLElement | null;

      if (link && 'tagName' in link && link.tagName.toLowerCase() === 'a') {
        link.setAttribute('target', '_blank');
      }
    };

    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [isFeatureAvailable]);
}
